import { connect } from 'react-redux';
import {
  getLocationMarkers,
  getLocationList,
  mapCheckBoxUnChecked,
  mapCheckBoxDeselectAll,
  receivedLocation,
  mapCheckBoxSelectAll,
} from '../../../redux/actions/Locations';
import {
  droppingAnimationStart,
} from '../../../redux/actions/Orders';

const mapStateToProps = state => ({
  area: state.mainreducer.area,
  locationList: state.mainreducer.locationList,
  arealist: state.mainreducer.arealist,
  kind: state.mainreducer.kind,
  selectedLocations: state.mainreducer.selectedLocations,
  siteKey: state.mainreducer.siteKey,
  dynRemarketingId: state.mainreducer.dynRemarketingId,
});

const mapDispatchToProps = dispatch => ({
  onComponentDidMount(areaId, kind) {
    dispatch(getLocationMarkers(areaId, kind));
  },
  onCheckBoxClick(id, isSelected, updatedIdList, kind) {
    dispatch(mapCheckBoxUnChecked(id, isSelected));
    dispatch(getLocationMarkers(updatedIdList, kind));
  },
  deselectAllCheckBox() {
    dispatch(mapCheckBoxDeselectAll());
    dispatch(getLocationMarkers([]));
    dispatch(getLocationList([]));
  },

  selectAllCheckBox(updatedIdList, kind) {
    dispatch(mapCheckBoxSelectAll());
    dispatch(getLocationMarkers(updatedIdList, kind));
  },
  droppingAnimationStart(location) {
    dispatch(droppingAnimationStart(location));
  },
  receivedLocationList(locationsList) {
    dispatch(receivedLocation(locationsList))
  }
});

export default CityLeftPartComponent => connect(mapStateToProps, mapDispatchToProps)(CityLeftPartComponent);
